<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('search.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'search', params: { type: 'book' } }">{{ $t('search.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <application-list-button-toolbar></application-list-button-toolbar>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-form @submit="submitKeyword">
          <b-form-group :label="$t('search.type-selector.label')" label-cols-sm="2" label-size="lg">
            <b-form-select
              v-model.lazy="type"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="book">{{ $t('search.type-selector.option.book.label') }}</b-form-select-option>
              <b-form-select-option value="picture">{{ $t('search.type-selector.option.picture.label') }}</b-form-select-option>
              <b-form-select-option value="audiovisual">{{ $t('search.type-selector.option.series.label') }}</b-form-select-option>
              <b-form-select-option value="lendable_book" v-if="isNewFeatureEnabled">{{ $t('search.type-selector.option.lendable_book.label') }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group v-if="false && type === 'book'" label-cols-sm="2" label-size="lg">
            <template #label>{{ $t('search.category-selector.label') }}</template>
            <div class="d-flex align-items-center">
              <book-language-selector-button
                :languages="languages"
                @select="selectBookLanguage"
              ></book-language-selector-button>
              <b-button v-if="selected_book_language" variant="outline-danger" class="ml-2" @click="clearBookLanguage">
                {{ $t('search.category-selector.button.clear.label') }}
              </b-button>
              <span v-if="selected_book_language" class="ml-3">
                {{ $t('book.list.label.selected-language') }}：{{ $i18n.locale === 'tw' ? selected_book_language.chinese_name : selected_book_language.english_name }}
              </span>
            </div>
          </b-form-group>
          <b-form-group v-if="type === 'audiovisual'" label-cols-sm="2" label-size="lg">
            <template #label>{{ $t('search.category-selector.label') }}</template>
            <div class="d-flex align-items-center">
              <series-category-selector-button
                :categories="series_categories"
                @select="selectSeriesCategory"
              ></series-category-selector-button>
              <b-button v-if="selected_series_category" variant="outline-danger" class="ml-2" @click="clearSeriesCategory">
                {{ $t('search.category-selector.button.clear.label') }}
              </b-button>
              <span v-if="selected_series_category" class="ml-3">
                {{ $t('series.list.classified.label.selected-category') }}：{{ $i18n.locale === 'tw' ? selected_series_category.cag_name : selected_series_category.cag_name_en }}[{{ selected_series_category.cag_no }}]
              </span>
            </div>
          </b-form-group>
          <b-input-group size="lg">
            <b-form-input
              style="border-color: black; color: black"
              :placeholder="$t('search.keyword-inputor.hint')"
              v-model="keyword"
            ></b-form-input>
            <b-input-group-append>
              <b-button type="submit" variant="primary">{{ $t('search.button.search.label') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <book-card-list
      :books="results"
      v-if="type === 'book' && this.search_completed && results.length > 0"
    ></book-card-list>
    <picture-card-list
      :pictures="results"
      v-if="type === 'picture' && this.search_completed && results.length > 0"
    ></picture-card-list>
    <series-card-list
      :series="results"
      v-if="type === 'audiovisual' && this.search_completed && results.length > 0"
    ></series-card-list>
    <lendable-book-card-list
      :books="results"
      :show-search-bar="false"
      v-if="type === 'lendable_book' && this.search_completed && results.length > 0"
    ></lendable-book-card-list>
    <div class="row" v-if="this.search_completed && results.length > 0">
      <div class="col-12">
        <b-pagination
          v-model="page"
          :total-rows="total"
          :per-page="per_page"
          @change="pageChange"
          align="center"
          size="lg"
        ></b-pagination>
      </div>
    </div>
    <div class="row mt-3" v-if="this.search_completed && results.length === 0">
      <div class="col-12">
        <h5 class="text-danger font-weight-bold">{{ $t('search.message.no-result') }}</h5>
      </div>
    </div>
    <!-- 可借閱書籍提示燈箱 -->
    <b-modal
      id="lendable-book-notice-modal"
      :title="$t('lendable-book.list.modal.library-collection-inquiry-notice.title')"
      ok-only
      centered
    >
      <p class="mb-2 font-weight-bold text-primary">{{ $t('lendable-book.list.modal.library-collection-inquiry-notice.message.cannot-provide-borrow-and-return-services') }}</p>
      <p class="mb-2 font-weight-bold text-primary">{{ $t('lendable-book.list.modal.library-collection-inquiry-notice.message.borrow-in-person') }}</p>
      <p class="mb-0 font-weight-bold text-danger">{{ $t('lendable-book.list.modal.library-collection-inquiry-notice.message.includes-books-that-are-borrowed-but-not-returned-and-lost') }}</p>
      <template #modal-footer="{ ok }">
        <b-button class="w-100" variant="primary" @click="ok()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'
import { stringify } from 'query-params-helpers'

import BookLanguageSelectorButton from '@/components/buttons/BookLanguageSelectorButton.vue'
import SeriesCategorySelectorButton from '@/components/buttons/SeriesCategorySelectorButton.vue'

import ApplicationListButtonToolbar from '@/components/button-toolbars/application-list-button-toolbar/ApplicationListButtonToolbar'
import BookCardList from '@/components/lists/BookCardList'
import PictureCardList from '@/components/lists/PictureCardList'
import SeriesCardList from '@/components/lists/SeriesCardList'
import LendableBookCardList from '@/components/lists/LendableBookCardList'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'
import BookLanguageApiService from '@/services/budaedu-api-services/book-language-api-service.js'
import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'
import SeriesApiService from '@/services/budaedu-api-services/series-api-service.js'
import SeriesCategoryApiService from '@/services/budaedu-api-services/series-category-api-service.js'
import LendableBookApiService from '@/services/budaedu-api-services/lendable-book-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(PaginationPlugin)

Vue.use(BookApiService)
Vue.use(BookLanguageApiService)
Vue.use(PictureApiService)
Vue.use(SeriesApiService)
Vue.use(SeriesCategoryApiService)
Vue.use(LendableBookApiService)

export default {
  i18n,
  name: 'search',
  props: {
    // 
  },
  data() {
    return {
      type: 'book',
      keyword: '',
      search_completed: false,
      per_page: 12,
      page: 1,
      total: 0,
      results: [],
      default_photo: { url: 'img/common.jpg' },
      books: [],
      pictures: [],
      series: {},
      languages: [],
      series_categories: [],
      selected_book_language: null,
      selected_series_category: null
    }
  },
  computed: {
    isNewFeatureEnabled() {
      return process.env.VUE_APP_ENABLE_NEW_FEATURES !== 'false';
    },
    /**
     * 將使用者輸入的關鍵字（以空格隔開）解析為陣列
     * 同時支援半形空格、全形空格，並自動 trim 與合併連續空白
     */
    parsedKeywords() {
      return this.keyword.trim().split(/[\s\u3000]+/).filter(k => k.length > 0)
    }
  },
  watch: {
    type(new_val) {
      this.total = 0
      this.results = []
      this.selected_book_language = null
      this.selected_series_category = null
      this.keyword = ''
      this.search_completed = false
      if (new_val === 'lendable_book') {
        this.$nextTick(() => {
          this.$bvModal.show('lendable-book-notice-modal')
        })
      }
    }
  },
  methods: {
    submitKeyword(event) {
      event.preventDefault()
      this.page = 1
      this.setResultsAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setResultsAndPaging()
    },
    selectBookLanguage(val) {
      this.selected_book_language = this.languages.find(l => l.english_name === val)
      this.page = 1
      this.setResultsAndPaging()
    },
    clearBookLanguage() {
      this.selected_book_language = null
      this.page = 1
      this.setResultsAndPaging()
    },
    selectSeriesCategory(val) {
      this.selected_series_category = this.series_categories.find(c => c.cag_no === val)
      this.page = 1
      this.setResultsAndPaging()
    },
    clearSeriesCategory() {
      this.selected_series_category = null
      this.page = 1
      this.setResultsAndPaging()
    },
    async setResultsAndPaging() {
      let items = {}

      if (this.type == 'book') {
        items = await this.getBooks()
      } else if (this.type == 'picture') {
        items = await this.getPictures()
      } else if (this.type == 'audiovisual') {
        items = await this.getSeries()
      } else if (this.type == 'lendable_book') {
        items = await this.getLendableBooks()
      }
      
      this.results = items.data
      this.total = items.meta.total
      this.search_completed = true
    },
    async getBooks() {
      let items = {}
      const additional = `filter[have_efile]&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`

      if (this.selected_book_language) {
        // 有語言篩選：以 queryByLanguage 為主，多關鍵字直接附加在 additional 中
        let filterKeyword = ''
        if (this.parsedKeywords.length > 1) {
          filterKeyword = `&filter[of_keywords]=${this.parsedKeywords.join(',')}`
        } else if (this.parsedKeywords.length === 1) {
          filterKeyword = `&filter[of_keyword]=${this.parsedKeywords[0]}`
        }
        items = await this.$bookApiService.queryByLanguage(
          this.selected_book_language.english_name.toLowerCase(),
          `filter[have_efile]${filterKeyword}&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`
        )
      } else if (this.parsedKeywords.length > 1) {
        // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
        items = await this.$bookApiService.queryByKeywords(
          this.parsedKeywords.join(','),
          additional
        )
      } else if (this.parsedKeywords.length === 1) {
        // 單一關鍵字：維持原有 filter[of_keyword]
        items = await this.$bookApiService.queryByKeyword(
          this.parsedKeywords[0],
          additional
        )
      } else {
        items = await this.$bookApiService.query(additional)
      }

      const previewPromises = items.data.map(async (book) => {
        book.front_cover = await this.$bookApiService.getFrontCover(book, this.default_photo)
      })
      await Promise.all(previewPromises)
      
      return items
    },
    async getPictures() {
      let items = {}
      const additional = `filter[have_efile]&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`

      if (this.parsedKeywords.length > 1) {
        // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
        items = await this.$pictureApiService.queryByKeywords(
          this.parsedKeywords.join(','),
          additional
        )
      } else if (this.parsedKeywords.length === 1) {
        // 單一關鍵字：維持原有 filter[of_keyword]
        items = await this.$pictureApiService.queryByKeyword(
          this.parsedKeywords[0],
          additional
        )
      } else {
        items = await this.$pictureApiService.query(additional)
      }

      const previewPromises = items.data.map(async (picture) => {
        picture.preview = await this.$pictureApiService.getPreviewableEfile(picture, this.default_photo)
      })
      await Promise.all(previewPromises);
      
      return items
    },
    async getSeries() {
      let items = {}

      if (this.selected_series_category) {
        if (this.keyword != '') {
          items = await this.$seriesApiService.queryByKeyword(
            this.keyword,
            `filter[of_category]=${this.selected_series_category.cag_no}&order=cdate,desc&per_page=${this.per_page}&page=${this.page}`
          )
        } else {
          items = await this.$seriesApiService.queryByCategoryNo(
            this.selected_series_category.cag_no,
            `order=cdate,desc&per_page=${this.per_page}&page=${this.page}`
          )
        }
      } else {
        if (this.keyword != '') {
          items = await this.$seriesApiService.queryByKeyword(
            this.keyword,
            `order=cdate,desc&per_page=${this.per_page}&page=${this.page}`
          )
        } else {
          items = await this.$seriesApiService.query(
            `order=cdate,desc&per_page=${this.per_page}&page=${this.page}`
          )
        }
      }
      
      return items
    },
    async getLendableBooks() {
      let items = {}
      const additional = `order=added_date,desc&per_page=${this.per_page}&page=${this.page}`

      if (this.parsedKeywords.length > 1) {
        // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
        items = await this.$lendableBookApiService.queryByKeywords(
          this.parsedKeywords.join(','),
          additional
        )
      } else if (this.parsedKeywords.length === 1) {
        // 單一關鍵字：維持原有 filter[of_keyword]
        items = await this.$lendableBookApiService.queryByKeyword(
          this.parsedKeywords[0],
          additional
        )
      } else {
        items = await this.$lendableBookApiService.query(additional)
      }
      
      return items
    },
    async setLanguages() {
      let order = ''
      switch (this.$i18n.locale) {
        case 'tw':
          order = 'chinese_display_order,asc|english_name,asc'
          break
        case 'en':
          order = 'english_display_order,asc|english_name,asc'
          break
        default:
          order = 'english_display_order,asc|english_name,asc'
      }

      const items = await this.$bookLanguageApiService.queryTopLevel(`order=${order}`)
      this.languages = items.data
    },
    async setSeriesCategories() {
      let param = { order: 'cag_no,asc'}
      if (this.$i18n.locale === 'en') {
        param.filter = { cag_no: 'C016,C025,C036' }
      }
      
      const items = await this.$seriesCategoryApiService.query(stringify(param).substr(1))
      this.series_categories = items.data
    }
  },
  async created() {
    await this.setLanguages()
    await this.setSeriesCategories()
  },
  components: {
    ApplicationListButtonToolbar,
    BookCardList,
    BookLanguageSelectorButton,
    LendableBookCardList,
    PictureCardList,
    SeriesCardList,
    SeriesCategorySelectorButton
  },
  metaInfo() {
    return {
      title: this.$t('search.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>